// Central color palette with descriptive names for reuse
export const background_cream_color = '#F5F2EC';
export const surface_white_color = '#FFFFFF';

export const text_primary_brown_color = '#2E2A22';
export const text_dark_gray_color = '#333333';
export const text_muted_gray_color = '#666666';
export const text_white_color = '#FFFFFF';
export const text_white_muted_color = 'rgba(255, 255, 255, 0.9)';

export const border_soft_brown_color = '#E6E1D8';
export const border_light_gray_color = '#e0e0e0';

export const accent_indigo_color = '#667eea';
export const accent_indigo_light_color = '#8699f0';

export const icon_gray_color = '#6B6B6B';
export const disabled_gray_color = '#cccccc';

export const shadow_black_color = '#000000';


